import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, HStack, Image,  VStack, Spacer, Divider, Text
} from '@chakra-ui/react';
import { Form, Field } from 'react-final-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

import axios from 'axios';
import { useCookies } from 'react-cookie';

import { apiLoadAUserByPhone } from '../../../redux/apis/UserApis';
import { getAUser } from '../../../redux/selectors';
import { API_SUB_URL_USER, ERROR_CODES } from '../../../constants';

import Header from '../Header';
import Navbar from '../Navbar';
import DropZoneWithImage from '../../../components/DropZoneWithImage';
import { displayConfirmAlert } from '../../utils';

function UserInformation({ userDetail, apiLoadAUserByPhone }) {
    const mounted = useRef();
    const navigate = useNavigate();
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const [ portraitFile, setPortraitFile ] = useState(null);
    const [ isProcessing, setIsProcessing ] = useState(false);

    useEffect(() => {
        if(!mounted.current) {
            if(cookies?.loginCookie?.data?.phone) {
                apiLoadAUserByPhone({ id: cookies?.loginCookie?.data?.phone });
            }
            mounted.current = true;
        }
    });

    const validate = (values) => {
        const errors = {};

        if(!values.full_name) {
            errors.full_name = "Required";
        }
        if(!values.email) {
            errors.email = "Required";
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);

        try
        {
            let portrait_url = null;

            if(portraitFile) {
                // upload portrait
                let portraitFiledata = new FormData();
                portraitFiledata.append('uri', portraitFile);

                let resUpload = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/upload?subPath=users`, portraitFiledata, { 
                    headers: { "Content-Type": "multipart/form-data" },
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                });

                if(resUpload.data?.status === 200) {
                    portrait_url = resUpload.data.fileName;
                }
            }

            let response = await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_USER}/${userDetail.id}`, {
                ...values, 
                portrait_url: portrait_url || userDetail?.portrait_url
            }, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            if(response.data?.status === 200) {
                displayConfirmAlert("Bạn đã thay đổi thông tin thành công!", () => {
                    removeCookie("loginCookie", { path: "/" });
                    navigate("/login");
                })
            } else {
                toast.error(response.data?.msg, {
                    position: "bottom-right"
                });
            }
        }
        catch(error) {
            if(error?.code) {
                toast.error(`${ERROR_CODES[error?.code]} (${error?.code})`, {
                    position: "bottom-right"
                });
            }
        }

        setIsProcessing(false);
    }

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={{
                ...userDetail,
            }}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Box>
                            <Header />
                            <Navbar />

                            <Flex justify="center">
                                <VStack borderRadius={20} boxShadow="lg" bg="white.100" width={{base: "100%", md: "50%", lg: "50%"}} px={8} py={4}>
                                    <Heading my="10px" size="lg">Thông tin tài khoản</Heading>

                                    <Divider />
                                    
                                    <Field name="full_name">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Họ tên:</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập Họ tên' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <HStack w="100%" justify="flex-start">
                                        <Text fontWeight="400">Số Điện Thoại:</Text>
                                        <Text fontWeight="600">{userDetail?.phone}</Text>
                                    </HStack>

                                    <HStack w="100%" justify="flex-start">
                                        <Text fontWeight="400">Thuộc Phòng khám:</Text>
                                        <Text fontWeight="600">{userDetail?.companyDetail?.name}</Text>
                                    </HStack>

                                    {/* <Field name="phone">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Số Điện Thoại:</FormLabel>
                                                <Input {...input} type='tel' placeholder='Nhập Số điện thoại' isReadOnly={true} />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <FormControl isRequired>
                                        <FormLabel>Thuộc Phòng khám:</FormLabel>
                                        <Input value={userDetail?.companyDetail?.name} type='text' placeholder='Nhập Thuộc Phòng khám' isReadOnly={true}/>
                                    </FormControl> */}

                                    <Field name="email">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Email:</FormLabel>
                                                <Input {...input} type='email' placeholder='Nhập Email' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <FormControl mt={2}>
                                        <FormLabel>Ảnh đại diện</FormLabel>
                                        <HStack spacing={2}>
                                            {
                                                userDetail?.portrait_url && !portraitFile &&
                                                <Image alt="user_image" src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/users/${userDetail?.portrait_url}`} 
                                                    width="100px" height="100px"
                                                />
                                            }
                                            <DropZoneWithImage callback={setPortraitFile}/>
                                        </HStack>
                                    </FormControl>

                                    <Button colorScheme='green' type='submit' size="lg" isDisabled={!valid} mt={4}
                                        isLoading={isProcessing}
                                        loadingText="Đang cập nhật"
                                    >
                                        Cập nhật thông tin
                                    </Button>
                                </VStack>
                                <ToastContainer />
                            </Flex>
                        </Box>
                    </form>
                )
            }}
        />
    )
}

const mapStateToProps = (state) => {
    const userDetail =          getAUser(state);

    return { userDetail };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadAUserByPhone:                    payload => dispatch(apiLoadAUserByPhone(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserInformation);